import {UserLevel} from '@netx/core-user/constants';

export const ASSET_DOWNLOAD_MINUMUM_USER_LEVEL = UserLevel.CONSUMER;
export const ASSET_RESYNC_MINIMUM_USER_LEVEL = UserLevel.PRODUCER;

export enum AssetPref {
	CHECKSUM_ENABLED = 'metadata.checksumEnabled',
}

export const AudioFormatFamilyType = <const>{
	AUDIO: 'audio',
};
export const AudioFormatFamilies = Object.values(AudioFormatFamilyType);

export const DocumentFormatFamilyType = <const>{
	DOCUMENT: 'document',
	LAYOUT: 'layout',
};
export const DocumentFormatFamilies = Object.values(DocumentFormatFamilyType);

export const ImageFormatFamilyType = <const>{
	CAMERA_RAW: 'cameraRaw',
	IMAGE: 'image',
	RAW: 'raw',
	VECTOR: 'vector',
};
export const ImageFormatFamilies = Object.values(ImageFormatFamilyType);

export const VideoFormatFamilyType = <const>{
	VIDEO: 'video',
};
export const VideoFormatFamilies = Object.values(VideoFormatFamilyType);

export const MediaFormatFamilyType = <const>{
	...AudioFormatFamilyType,
	...VideoFormatFamilyType,
};
export const MediaFormatFamilies = Object.values(MediaFormatFamilyType);
